module.exports = __webpack_public_path__ + "fonts/subset-Axiforma-Heavy.3a83f06.woff";